import React from 'react'
import Layout from '../../components/layout/Layout'

const NotActivateAccountView = () => {
    return (
        <Layout>
            <h2 className='txt_title'>Cuenta no Activada</h2>
        </Layout>
    )
}

export default NotActivateAccountView
